module.exports = __webpack_public_path__ + "media/img/S2U-Logo-Institution_White-0480d8117a26a57e2e38b6bf757ad0d2.png";